import React, { useState } from 'react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';

const faqSections = [
  {
    category: 'Cross Trade',
    items: [
      {
        q: 'Hvad er cross trade?',
        a: (
          <p>
            <Link to="/cross-trade" className="text-sky-700 font-semibold hover:underline">
              Cross trade
            </Link>{' '}
            er transporter som ikke går via Danmark. Altså hvor der hverken afhentes eller leveres gods i Danmark.
          </p>
        )
      }
    ]
  },
  {
    category: 'Fortoldning',
    items: [
      {
        q: 'Hvornår skal der laves en fortoldning?',
        a: 'Når der importeres gods fra 3. land (land udenfor toldunionen EU) laves der en fortoldning efter gældende regler og procedurer fra told & skat.'
      },
      {
        q: 'Hvornår skal der laves en eksportudførsel?',
        a: 'Når der eksporteres gods fra toldunionen EU til 3. land (land udenfor toldunionen EU) skal der laves en eksportudførsel efter gældende regler og procedurer fra told & skat.'
      },
      {
        q: 'Skal man være importørregistreret / eksportørregistreret?',
        a: 'For som firma at kunne importere gods fra 3. land skal man være importørregistreret . På samme måde skal man være eksportørregistreret for som firma at kunne eksportere til 3. land. Det er gratis at blive importør og eksportør registreret. Det gøres via virk.dk. Er man ikke importørregistreret inden godset kommer til Danmark, så skal importmoms og evt. importtold betales forud inden godset bliver frigivet af told og skat.'
      },
      {
        q: 'Hvad HS-Kode (Harmonized System Code) - toldtarifnummer/varekode?',
        a: (
          <div className="space-y-3">
            <p>
              Det er et nummersystem, som omfatter stort set alle varer i verdenen. Systemet anvendes af ca. 200 lande. Toldtarifnummeret beskriver entydigt de forskellige godstyper så varestrømme kan følges og således at der opkræves korrekt told for de varer som importeres.
            </p>
            <p>
              Alle varer, der importeres eller eksporteres til og fra lande uden for EU, skal angives med en varekode. En varekode består af 8 (eksport) eller 10 (import) cifre.
            </p>
            <p>
              De første 6 cifre kommer af det internationale HS-system (Harmonized System). Derfor bliver de første 6 cifre af en varekode også kaldt for en HS-kode og denne bør være den samme i hele verdenen, hvorimod de sidste 2 til 4 cifre godt kan variere fra land til land.
            </p>
            <p>
              De næste to cifre kommer af KN (Kombineret Nomenklatur), der er EU’s varenomenklatur. KN-varekoden kombinerer den 6-cifrede HS-kode med yderligere to cifre. Den 8-cifrede varekode bruges ved eksport.
            </p>
            <p>
              De sidste to cifre kommer af TARIC (EU’s integrerede toldtarif) og afgør bl.a., om der er toldsuspension, mulighed for toldnedsættelse eller antidumpingtold på dine importvarer. Den 10-cifrede varekode bruges ved import. I særlige tilfælde kan der desuden være tilknyttet en tillægskode i forbindelse med import.
            </p>
          </div>
        )
      },
      {
        q: 'Hvorfor er det vigtig at bruge rigtig toldtarifnummer/varekode?',
        a: 'Det er det fordi det er den kode som ved import er nøglen til at afgøre om der skal betales told af en pågældende vare og i givet fald hvor meget told der skal betales.'
      },
      {
        q: 'Hvad er et EORI-nummer?',
        a: (
          <div className="space-y-2">
            <p>
              EORI-nummer er et særligt EU-nummer, som i Danmark består af CVR-/SE-nummeret med landefortegnelse som første to tegn, f.eks. DK12345678. Når en eksportør har dette nummer, ved toldmyndighederne i de øvrige EU lande, at virksomheden er registreret som eksportør. Nummeret kan bruges, når toldformaliteter foretages i et andet EU land, end dér hvor eksportøren er hjemmehørende.
            </p>
            <p>
              EORI er en engelsk forkortelse for Economic Operators Registration and Identification og EORI-nummeret registreres i et fælles EU-register over virksomheder, der er beskæftiget med aktiviteter i forbindelse med import og/eller eksport til/fra lande uden for EU. Formålet med EORI er at sikre, at virksomheder kan identificeres entydigt og effektivt i hele EU.
            </p>
          </div>
        )
      },
      {
        q: 'Hvornår kan man få brug for Toldoplag?',
        a: (
          <ul className="list-disc pl-5 space-y-1">
            <li>Importør får leveret et forkert parti varer som efter afklaring skal returneres til afsender i 3. land.</li>
            <li>Importør ved ikke om køber vil være fra EU eller 3. land f.eks. sælger importør et parti varer til Norge efter afsendelse fra Indien.</li>
            <li>Brexit bliver en realitet, hvor UK får status som 3. land og der er udfordringer med papirerne ved import af vare.</li>
          </ul>
        )
      }
    ]
  },
  {
    category: 'Eksportudførsel',
    items: [
      {
        q: 'Hvornår skal der laves en eksport udførsel?',
        a: 'Når der eksporteres til 3. land (land udenfor toldunionen EU)'
      },
      {
        q: 'Hvad er et MRN-nummer (Movement Reference Number)?',
        a: 'Unikt referencenummer for bl.a. EAD (elektronisk udførselsledsagedokument).'
      },
      {
        q: 'Hvad er E-Export?',
        a: 'Online system til at anlægge eksportudførelse.'
      },
      {
        q: 'Hvad er et oprindelseslandcertifikat certifikat?',
        a: 'Et oprindelseslandcertifikat kan have mange udformninger og navne. Primært er det som navnet antyder et certifikat som dokumentere hvor en vare har oprindelse.'
      },
      {
        q: 'Skal man have et oprindelseslandcertifikat?',
        a: (
          <div className="space-y-2">
            <p>
              Normalt er det klogt at have fordi reglerne og toldmæssige bestemmelser kan ændre sig hurtigt. Hvorvidt der er told på en vare eller om der gælder en toldpræference så varen er undtage for told er ofte afhængig af hvilket land varen har oprindelse i, hvilket så skal dokumenteres for at man kan få toldfritagelse. Herunder nogle af de oprindelseslandslandscertifikater, tolddokumenter, der hyppigst bliver brugt:
            </p>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>
                <strong>GSP-Certifikat - General System of Preference - Form A</strong> er et speciel oprindelseslandscertifikat som primært bruges af GSP landene. Systemet udfases og det er meningen at GSP landene skal godkendes i REX Systemet og derefter de enkelte eksportører og så kan eksportørerne påtegne eksportdokumentet autorisationsnummer og oprindelsesland. Lidt som det kendes fra fakturaerklæringssystemet.
              </li>
              <li>
                <strong>EUR-1 Certifikat</strong> - er et varecertifikat/tolddokument, der siker toldfritagelse i samhandlen mellem EU og nogle lande.
              </li>
              <li>
                <strong>ATR-Certifikat</strong> - der er gældende for handel mellem Tyrkiet og EU og er egentlig nærmere et varecertifikat/tolddokument som sikre toldfritagelse i toldunionen EU & Tyrkiet. Visse vare er dog untaget i denne union såsom kul, stål m.m.
              </li>
            </ul>
          </div>
        )
      }
    ]
  },
  {
    category: 'Import Sø',
    items: [
      {
        q: 'Skal B/L være i originaler eller skal B/L være telex released / surrendered at destination?',
        a: (
          <div className="space-y-2">
            <p>
              Sendes på et originalt B/L så er der typisk 3-5 originaler af dokumentet. Et af disse skal indleveres på modtager destinationen for at rederiagent / rederie vil udlevere godset. Derfor skal originalerne sendes rettidigt via kurer el. lign. så der er mulighed for at få godset udleveret på destinationen rettidigt.
            </p>
            <p>
              Sendes "telex released" så bliver der normalt lavet et egentlig B/L på afsender destinationen som så bliver indleveret (surrendered at destination) i afsenderlandet til rederiagent eller rederi. Herefter frigivet godset til udlevering mod digital kopi.
            </p>
            <p>
              En grund til at fastholde original B/L er, at afsender på den måde kan sikre han får fuld betaling inden originalerne sendes. Originalt B/L er et ihændehaver dokument og kaldes også nøglen til lasten. Har man det originale B/L kan man få godset udleveret ellers ikke.
            </p>
          </div>
        )
      },
      {
        q: 'Hvornår skal vi modtage originale dokumenter?',
        a: 'De skal kunne være fremme hos rederiagent / rederi inden godset skal/kan hentes ud af havnen. Så jeg vil sige senest en uge før skibets ankomst for at undgå unødvendig stress.'
      },
      {
        q: 'Hvilket dokumenter skal bruges for, at der kan laves en fortoldning i Danmark?',
        a: (
          <div className="space-y-2">
            <p>
              Typisk skal man som minimum bruge kopi international faktura, kopi af B/L og en pakkeliste. Det er importørens ansvar at have nødvendige tilladelser/certifikater til at importere gods som kræver sådanne. Ligeledes skal importøren sikre sig at det gods som sendes kan/må importeres i EU/DK.
            </p>
            <p>
              Oprindelseslandscertifikater, handelscertifikater og faktura påtegning kan ofte betyde forskellen på om der skal betales importtold. Vi prøver altid at vejlede, såfremt vi er med tidlig i processen, men det er importørens eget ansvar at have styr på disse forhold.
            </p>
          </div>
        )
      },
      {
        q: 'Skal containeren leveres med besima / sideloader eller på chassis?',
        a: 'Har man rampe kan man typisk gå/køre ind i containeren mens den står på chassis (på hjulene). Har man ikke rampe kan det være en fordel at få containeren sat på jorden, d.v.s. løftet ned fra chassiet. En besima eller sideloader er en speciel kranbil som kan køre en container frem til levering og stille den af på jorden ved siden af chassiet. Typisk koster det 50 % ekstra at få en container leveret med besima/sideloader.'
      },
      {
        q: 'Hvor lang tid har jeg til at tømme en container?',
        a: 'Som standard har man 1 time til at tømme en container. Bruges der mere tid må man forvente at skulle betale ekstra per påbegyndt time.'
      },
      {
        q: 'Hvornår skal en container hentes på havnen?',
        a: 'Det afhænger af valgte service og havn. Så det er noget man skal afklare fra gang til gang. I nogle havene skal godset afhentes i løbet af timer. I andre havne kan man have 2 til 5 dage. Håndterer vi levering af din container er det noget vi styrer af efter bedste evne.'
      },
      {
        q: 'Hvornår skal en container leveres tilbage til havnen?',
        a: 'Det er forskelligt fra rederi til rederi og fra havn til havn, men man har typisk nogle dage f.eks. 2-5 dage fra containeren hentes og til den skal retur. Håndterer vi levering af din container er det noget vi styrer af efter bedste evne.'
      },
      {
        q: 'Hvad betyder detention?',
        a: 'Når en container forlader destinationshavnen har ejeren af godset et fastsat tidsrum (afheængig af rederi), hvor contineren frit kan tilbageleveres uden meromkostning. Er containeren længere tid om at returnere til havnen end det som er med frit skal der betales detention for leje af udstyr. Håndterer vi levering af din container er det noget vi styrer af efter bedste evne.'
      },
      {
        q: 'Hvad betyder demurrage?',
        a: 'Når en container ankommer til destinationshavnen har ejeren af godset et fastsat tidsrum (afhængig af havn, rederi m.m.), hvor containeren frit kan afhentes uden meromkostning. Står containeren længere tid end det som er med frit skal der betales demurrage for leje af udstyr og plads. Håndterer vi levering af din container er det noget vi styrer af efter bedste evne.'
      },
      {
        q: 'Skal jeg selv rengøre en container?',
        a: 'Ja det skal man typisk. Vurderer containerterminalen, at det ikke er gjort kan det medføre ekstraomkostninger til fejning/rengøring.'
      },
      {
        q: 'Hvad gør jeg, hvis der er hul i eller skader på en container?',
        a: 'Så skriver du på fragtbrevet du modtog ved levering for underskrift, at der var hul i / skader på containeren ved ankomsten og så præcist som muligt, hvor og hvad der er skadet. Tag gerne billede af container ved ankomsten. Specielt hvis skaderne er synlige udefra.Tag gerne en kopi af fragtbrevet med forbehold til dig selv og gem den.'
      },
      {
        q: 'Hvor lang tid tager det at få en container fra Kina?',
        a: 'Det er afhængig af hvorfra i Kina og om den sendes via sø eller bane. Ligeledes er det også afhængig af den valgte service og routing. Typisk arbejder vi ud fra ETS Estimated time of shipping og ETA Estimated time of arrival. Typisk hænger pris og service sammen og vi kan oplyse forventningerne basis et givent tilbud.'
      },
      {
        q: 'Hvad er en ”shippers own” container?',
        a: 'En container som er ejet af afsender i modsætning til langt de fleste containere som ejes af rederierne. For at en sådan kan bruges i forbindelse med international søfragt skal den have gyldigt CSC (Container Safety Certificate).'
      },
      {
        q: 'Hvad betyder “shipper stove load and count”?',
        a: 'Det er et udtryk som primært bruges i forbindelse med fragt af gods i container. Det betyder, at det er den fysiske afsender som er ansvarlig for at der mængdemæssigt er det gods som er angivet, endvidere at godset er stuvet, sikret og pakket forsvarligt. En container forsegles typisk efter lastning. Er sejlet ikke brudt ved ankomst må det formodes at det indvendige af containeren er som efterladt af den fysiske afsender.'
      }
    ]
  }
];

export default function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggle = (catIdx, itemIdx) => {
    const key = `${catIdx}-${itemIdx}`;
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <>
      <SEO
        title="Fastlane ApS :: Conditions"
        description="Få svar på ofte stillede spørgsmål om told, import, eksportudførsel, HS-koder, søfragt, containere og cross trade hos Fastlane ApS."
        canonicalUrl="https://fastlane.dk/spoergsmaal-svar-fragt"
      />

      <PageHeader
        title="Ofte Stillede Spørgsmål"
        subtitle="Vejledning om fortoldning, eksportudførsel, søfragt, B/L og containerbetingelser."
        breadcrumbs={[{ label: 'Ofte stillede spørgsmål' }]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {faqSections.map((sec, catIdx) => (
            <div key={catIdx} className="space-y-4">
              <h2 className="text-2xl font-bold text-[#0f2b48] border-b border-slate-200 pb-2 flex items-center gap-2.5">
                <span className="w-2.5 h-2.5 rounded-full bg-[#c52828]" />
                {sec.category}
              </h2>

              <div className="space-y-3">
                {sec.items.map((item, itemIdx) => {
                  const isOpen = Boolean(openItems[`${catIdx}-${itemIdx}`]);
                  return (
                    <div
                      key={itemIdx}
                      className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50/50 transition-colors"
                    >
                      <button
                        type="button"
                        onClick={() => toggle(catIdx, itemIdx)}
                        className="w-full py-4 px-5 text-left font-bold text-slate-800 hover:text-[#0f2b48] flex items-center justify-between gap-4 cursor-pointer focus:outline-hidden"
                      >
                        <span className="text-base sm:text-lg">{item.q}</span>
                        <i
                          className={`fa-solid fa-chevron-down text-xs text-slate-400 transition-transform duration-200 shrink-0 ${
                            isOpen ? 'rotate-180 text-sky-600' : ''
                          }`}
                          aria-hidden="true"
                        />
                      </button>

                      {isOpen && (
                        <div className="px-5 pb-5 pt-1 text-sm text-slate-700 leading-relaxed border-t border-slate-100 bg-white">
                          {typeof item.a === 'string' ? <p>{item.a}</p> : item.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* Quick Help box */}
          <div className="p-6 sm:p-8 bg-sky-50 rounded-2xl border border-sky-100 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-lg font-bold text-[#0f2b48]">Fandt du ikke svaret på dit spørgsmål?</h3>
              <p className="text-sm text-slate-600 mt-1">
                Vores speditører på fragtkontoret i Esbjerg sidder klar til at rådgive om din konkrete forsendelse.
              </p>
            </div>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#0f2b48] hover:bg-[#1c4570] text-white text-sm font-semibold transition-colors shrink-0"
            >
              <span>Kontakt os</span>
              <i className="fa-solid fa-arrow-right ml-2 text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
